import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/76_card_back_palace/76_card_back_palace"
 * Contains 1 texture(s)
 */
export class CardsBacks76CardBackPalaceAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/76_card_back_palace/76_card_back_palace';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '76_palace.png'
    ] as const;
}
